import {Component, ElementRef, inject, ViewChild} from '@angular/core';
import { AppMenu } from './app.menu';

@Component({
    selector: '[app-sidebar]',
    standalone: true,
    imports: [AppMenu],
    template: `<nav app-menu class="layout-sidebar" id="layout-menu-principal" aria-label="Menu principal"></nav>`,
})
export class AppSidebar {
    el = inject(ElementRef);

    @ViewChild(AppMenu) appMenu!: AppMenu;
}
